export enum CartItemCode {
  DOMAIN_REGISTER = 'domain-register',
  DOMAIN_TRANSFER = 'domain-transfer',
}
